import React from 'react';

export const ErrorTextBlurb: React.FC<{errorMessage?: string}> = ({errorMessage}) => {
  if (!errorMessage) {
    return null;
  }

  return <div className="text-red-700 text-11px pt-2 error-text">{errorMessage}</div>;
};
